import { createFileRoute } from "@tanstack/react-router";

import { seoHead } from "@/lib/seo";
import { DASHBOARD_FONT_LINKS } from "@/components/dashboard/shared";
import { ClaimFlow } from "./-claim-flow";

export type ClaimSearch = {
  __clerk_ticket?: string;
};

export const Route = createFileRoute("/claim/")({
  validateSearch: (search: Record<string, unknown>): ClaimSearch => ({
    __clerk_ticket:
      typeof search.__clerk_ticket === "string" && search.__clerk_ticket.length > 0
        ? search.__clerk_ticket
        : undefined,
  }),
  head: () => {
    const head = seoHead({
      title: "Claim your account - Bavimail",
      description: "Claim the Bavimail account your agent set up for you.",
      path: "/claim/",
      noindex: true,
    });

    return {
      ...head,
      links: [...head.links.filter((link) => link.rel === "canonical"), ...DASHBOARD_FONT_LINKS],
    };
  },
  component: ClaimRoute,
});

function ClaimRoute() {
  const { __clerk_ticket: ticket } = Route.useSearch();
  return <ClaimFlow ticket={ticket} />;
}
